import React, { useState, useEffect, useRef } from 'react';
import { Card, Row, Col, Form, Button, Table, Modal } from 'react-bootstrap';
import { MdAddCircle } from 'react-icons/md';
import { FiMinusCircle } from "react-icons/fi";
import { Link, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { RiDeleteBin6Fill } from "react-icons/ri";
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import Addproduct from '../commanpage/Addproduct';
import Category_Design from '../commanpage/Category_Design';
import Category_Design_Edit from '../commanpage/Category_Design_Edit';
import { FaEye } from "react-icons/fa";
import OrderProductPdfDownload from './OrderProductPdfDownload'
import AddproductRaw from '../commanpage/AddrowmaterialOrder';
import $, { get } from 'jquery'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { RiDeleteBin6Line } from "react-icons/ri";
import Multiselect from 'multiselect-react-dropdown';
import { v4 as uuidv4 } from 'uuid';
export default function Takeorder() {
    const [errors, setErrors] = useState({});
    const token = localStorage.getItem('token');
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [productdata, setproduct] = useState([]);
    const [design_category_list, setDesignCategorylist] = useState([]);
    const [viewdata, setViewdata] = useState([]);
    const [accountlist, setAccountList] = useState([]);
    const [account_mode, setAccountMode] = useState('');
    const [venderlist, setVenderlist] = useState([]);
    const [Componentlist, setComponentlist] = useState([]);
    const [productorderdata, setproductorder] = useState([]);
    const [modalState, setModalState] = useState({ addproduct: false, addraw: false, orderconfirmation: false, adddesignCategory: false, category_design_edit: false });
    const handleCloseEditModal = () => setShowEditModal(false);
    const handleShowEditModal = () => setShowEditModal(true);
    const [showEditModal, setShowEditModal] = useState(false);
    const [searchNameList, setSearchNameList] = useState([]);
    const [filteredNameList, setFilteredNameList] = useState([]);
    const [RawGstAmount, setRawGstAmount] = useState();
    const [selectedComponents, setSelectedComponents] = useState([]);
    const [filteredComponents, setFilteredComponents] = useState([]);
    // const [fields, setFields] = useState([]);

    // const [rows1, setRows1] = useState([])
    // ;
    // const [rows1, setRows1] = useState(() => {
    //     const savedRows = localStorage.getItem('rows1');
    //     return savedRows ? JSON.parse(savedRows) : []; // Parse saved JSON or default to an empty array
    // });

    // Save rows1 state to localStorage whenever it changes
    // useEffect(() => {
    //     localStorage.setItem('rows1', JSON.stringify(rows1));
    // }, [rows1]);
    const [rows, setRows] = useState([]);
    const [fields, setFields] = useState([]);
    const categoryOptions = categories.map((item) => ({ value: item.id, label: item.name, }));
    const vendorOptions = venderlist.map((item) => ({ value: item.id, label: item.vendor_name, }));
    const componentOptions = Componentlist.map((item) => ({
        value: item.id,
        label: item.name,
        category_id: item.category_Id,
    }));
    const [successMessage, setSuccessMessage] = useState("");
    const handleAddRow = () => {
        setRows1([
            ...rows1,
            {
                category_id: null,
                product_id: null,
                area: 0,
                fields: [],
            }
        ]);
        toast.success("New Area added successfully!");
    };
    // const handleCheckButtonClick = (index) => {
    //     const updatedRows = [...rows1];

    //     // Extract available components and vendors dynamically from the data or use hardcoded lists
    //     const components = updatedRows[index].fields.map(field => field.component);  // Extract all components for the row
    //     const vendorIds = updatedRows[index].fields.map(field => field.vendor_id); // Extract all vendor_ids for the row

    //     // Ensure there's a default set of components and vendor_ids if not present
    //     const defaultComponents = [3, 4];  // Example: multiple components
    //     const defaultVendorIds = [14, 15];  // Example: multiple vendor_ids

    //     // Use defaults if no components or vendor_ids found
    //     const assignedComponents = components.length ? components : defaultComponents;
    //     const assignedVendorIds = vendorIds.length ? vendorIds : defaultVendorIds;

    //     if (updatedRows[index].fields.length > 0) {
    //         updatedRows[index].fields = updatedRows[index].fields.map((field, i) => {
    //             return {
    //                 ...field,
    //                 extraFields: assignedComponents.map((component, j) => ({
    //                     component: component,         // Assign dynamic components
    //                     vendor_id: assignedVendorIds[j] || assignedVendorIds[0]  // Use dynamic vendor_ids, fallback to first vendor_id
    //                 }))
    //             };
    //         });
    //     }

    //     setRows1(updatedRows);
    // };



    const handleCheckButtonClick = (index) => {
        const updatedRows = [...rows1];
        if (updatedRows[index].fields.length > 0) {
            const firstFieldExtraFields = updatedRows[index].fields[0]?.extraFields || [];
            updatedRows[index].fields = updatedRows[index].fields.map((field, i) => {

                const newExtraFields = firstFieldExtraFields.map(extra => ({
                    component: extra.component,
                    vendor_id: extra.vendor_id
                }));
                return {
                    ...field,
                    extraFields: newExtraFields
                };
            });
        }
        setRows1(updatedRows);
    };


    // const handleRowChange = (index, field, value) => {
    //     const updatedRows = [...rows1];
    //     updatedRows[index][field] = value;
    //     console.warn("dd", field)
    //     console.warn("ddsds", rows1)
    //     if (field == 'category_id') {
    //         const filtered = componentOptions.filter(component => component.category_id === value);
    //         console.warn("d'dfff", filtered)
    //         setFilteredComponents(filtered);
    //     }
    //     if (field === "area") {
    //         const areaValue = value;
    //         updatedRows[index].fields = [];
    //         for (let i = 0; i < areaValue; i++) {
    //             updatedRows[index].fields.push({
    //                 id: uuidv4(),
    //                 area_description: '',
    //                 cost_price: '',
    //                 sale_price: '',
    //                 extraFields: []
    //             });
    //         }
    //     }

    //     setRows1(updatedRows);
    //     console.log("rowssssssss", updatedRows);
    // };

    const handleRowChange = (index, field, value) => {
        const updatedRows = [...rows1];
        updatedRows[index][field] = value;

        console.warn("dd", field);
        console.warn("ddsds", rows1);

        if (field === 'category_id') {
            const filtered = componentOptions.filter(component => component.category_id === value);
            console.warn("Filtered components", filtered);
            setFilteredComponents(filtered);
        }

        if (field === 'area') {
            const areaValue = value;
            updatedRows[index].fields = [];

            // Add rows for each area
            for (let i = 0; i < areaValue; i++) {
                updatedRows[index].fields.push({
                    id: uuidv4(),
                    area_description: '',
                    cost_price: '',
                    sale_price: '',
                    extraFields: [{
                        component: null,  // or a default value
                        vendor_id: null,  // or a default value
                    }]  // Ensure at least one extraField exists
                });
            }
        }

        // If description, sale_price, or cost_price is modified, ensure at least 1 extraField
        if (field === 'area_description' || field === 'cost_price' || field === 'sale_price') {
            const fieldRow = updatedRows[index].fields;
            fieldRow.forEach((fieldData) => {
                if (fieldData.extraFields.length === 0) {
                    fieldData.extraFields.push({
                        component: null, 
                        vendor_id: null, 
                    });
                }
            });
        }

        setRows1(updatedRows);
        console.log("Updated rows: ", updatedRows);
    };



    const handleDeleteRow = (index) => {
        const updatedRows = [...rows1];
        updatedRows.splice(index, 1);
        setRows1(updatedRows);
    };
    const handleFieldChange = (rowIndex, fieldIndex, field, value) => {
        const updatedRows = [...rows1];
        updatedRows[rowIndex].fields[fieldIndex][field] = value;
        setRows1(updatedRows);
    };

    const handleAddMoreComponentVendor = (rowIndex, fieldIndex) => {
        const updatedRows = [...rows1];
        updatedRows[rowIndex].fields[fieldIndex].extraFields.push({
            component: null,
            vendor_id: null,
        });
        setRows1(updatedRows);
    };

    const handleComponentSelection = (rowIndex, fieldIndex, extraFieldIndex, selected) => {
        const updatedRows = [...rows1];
        updatedRows[rowIndex].fields[fieldIndex].extraFields[extraFieldIndex].component = selected ? selected.value : null;
        setRows1(updatedRows);
    };

    const handleVendorSelection = (rowIndex, fieldIndex, extraFieldIndex, selected) => {
        const updatedRows = [...rows1];
        updatedRows[rowIndex].fields[fieldIndex].extraFields[extraFieldIndex].vendor_id = selected ? selected.value : null;
        setRows1(updatedRows);
    };

    const handleDeleteExtraField = (rowIndex, fieldIndex, extraFieldIndex) => {
        const updatedRows = [...rows1];
        updatedRows[rowIndex].fields[fieldIndex].extraFields.splice(extraFieldIndex, 1);
        setRows1(updatedRows);
    };
    const [currentEditId, setCurrentEditId] = useState(null);
    const getSavedData = (key, defaultValue) => JSON.parse(localStorage.getItem(key)) || defaultValue;

    const [selectedOrderType, setSelectedOrderType] = useState(() => localStorage.getItem("selectedOrderType") || '');
    const [isCGSTChecked, setIsCGSTChecked] = useState(() => localStorage.getItem("isCGSTChecked") || '');
    // const [rows1, setRows1] = useState(() => getSavedData("rows1", {
    //     category_id: null, product_id: null, area: 0, fields: [],
    // }));
    const [rows1, setRows1] = useState(() => getSavedData("rows1", [
        { category_id: null, product_id: null, area: 0, fields: [] }
    ]));
    

    const [formData, setFormData] = useState(() => getSavedData("formData", {
        order_date: new Date().toISOString().split("T")[0], customer_type: "", customer_name: "", mobile_number: "",
        invoice_number_manual: '', vehicle_number: '', gst_in_no: '', c_gst: '',
        s_gst: '', description: '', email: "", site_name: "", address1: "",
        address2: "", city: "", state: "", pincode: "", manufacture: "Manufacture",
        amount: "", receiver_name: "", payer_name: "", delivery_date: "", design_price: ''
    }));

    const [rowother, setRowother] = useState(() => getSavedData('rowother', [{
        tr_charge: null, lable_charge: null, name: ''
    }]));

    const [rowdesing, setRowdesing] = useState(() => getSavedData('rowdesing', [{
        design_category_id: null, design_description: null
    }]));


    const handleAddRowOther = () => { setRowother([...rowother, { tr_charge: null, lable_charge: null, name: '' }]); };
    const handleAddRowDesign = () => { setRowdesing([...rowdesing, { design_category_id: null, design_description: null }]); };
    const navigate = useNavigate();

    const filterComponentList = (category_id) => {
        return Componentlist.filter(component => component.category_Id === category_id);
    };

    useEffect(() => localStorage.setItem('formData', JSON.stringify(formData)), [formData]);
    useEffect(() => localStorage.setItem("selectedOrderType", selectedOrderType), [selectedOrderType]);
    useEffect(() => localStorage.setItem("isCGSTChecked", isCGSTChecked), [isCGSTChecked]);
    useEffect(() => localStorage.setItem('rows', JSON.stringify(rows)), [rows]);
    useEffect(() => localStorage.setItem('rows1', JSON.stringify(rows1)), [rows1]);
    useEffect(() => localStorage.setItem('rowother', JSON.stringify(rowother)), [rowother]);
    useEffect(() => localStorage.setItem('rowdesing', JSON.stringify(rowdesing)), [rowdesing]);

    useEffect(() => {
        if (selectedOrderType === 'product' || selectedOrderType === 'extraquotation') {
            setFormData((prevData) => ({
                ...prevData,
                manufacture: 'Manufacture', // Set manufacture to 'Manufacture' if product or extraquotation
            }));
        }
    }, [selectedOrderType]);

    const handleOrderTypeChange = (event) => {
        const newOrderType = event.target.value;
        setSelectedOrderType(newOrderType);

        if (newOrderType === 'product' || newOrderType === 'extraquotation') {
            setFormData((prevData) => ({
                ...prevData,
                manufacture: 'Manufacture', // Set manufacture to 'Manufacture' if product or extraquotation
            }));
        }
        // Reset formData with empty values
        setFormData({
            c_gst: '',
            s_gst: '',
            design_price: '',
            delivery_date: '',
        });
        // Reset rows with one default row
        setRows([{
            category_id: null, product_id: null, vendor_id: null, qty: '', price: '', gst: ''
        }]);

        setRows1([{
            category_id: null, product_id: null, area: 0, fields: [],
        }]);

        // Reset rowdesing with one default row
        setRowdesing([{
            design_category_id: null, design_description: null
        }]);

        // Reset rowother with one default row
        setRowother([{
            tr_charge: null, lable_charge: null, name: ''
        }]);
    };
    const handleCheckboxChange = (e) => {
        setIsCGSTChecked(e.target.checked);
    };


    const getProductOptionsForRow = (category_id, manufacture) => {
        console.log(productdata);
        return productdata.filter(item => item.category_id == category_id && item.manufacture == manufacture)
            .map(item => ({
                value: item.id, label: item.name, sale_price: item.sale_price, cost_price: item.cost_price
            }));
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name != 'amount') {
            setErrors((prevErrors) => ({ ...prevErrors, [name]: false }));
        }

        if (name === 'mobile_number') {
            const formattedValue = value.replace(/\D/g, '').slice(0, 10);
            setFormData({ ...formData, [name]: formattedValue });

            if (formattedValue.length !== 10) {
                setErrors((prevErrors) => ({ ...prevErrors, [name]: 'Mobile number must be 10 digits long' }));
            } else {
                setErrors((prevErrors) => ({ ...prevErrors, [name]: false }));
            }
        } else if (name === 'vehicle_number' || name === 'gst_in_no') {
            setFormData({
                ...formData,
                [name]: value.toUpperCase(),
            });
        } else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
        if (name === 'customer_name') {
            if (value.trim() !== '') {
                filterSearchName(value);
            } else {
                setSearchNameList([]);
            }
        }
    };
    const handleSelectChange = (name, selectedOption) => {
        console.warn(name, selectedOption);

        // Update formData based on the selected field
        if (name === 'category_id' || name === 'account_name' || name === 'account_id') {
            setFormData({
                ...formData,
                [name]: selectedOption ? selectedOption.value : null,
            });

            // If account_id is selected, update the account_mode based on the selected option
            if (name === 'account_id' && selectedOption) {
                setAccountMode(selectedOption.account_type || '');
            }
        } else if (name === 'product_id') {
            const selectedProduct = selectedOption
                ? { id: selectedOption.value, name: selectedOption.label }
                : null;
            setFormData({ ...formData, [name]: selectedProduct });
        } else {
            setFormData({
                ...formData,
                [name]: selectedOption,
            });
        }
    };

    const handleRowChangeOther = (index, field, value) => {
        const updatedRows = [...rowother];
        updatedRows[index][field] = value;
        setRowother(updatedRows);
    };
    const handleRowChangeDesign = (index, field, value) => {
        // alert(value);
        const updatedRows = [...rowdesing];
        // console.warn(updatedRows);
        updatedRows[index][field] = value;
        setRowdesing(updatedRows);
    };
    const validateForm = () => {
        const newErrors = {};
        console.log(formData);
        Object.keys(formData).forEach((key) => {
            if (!formData[key] && key !== 'email' && key !== 'site_name' && key !== 'pincode' && key !== 'address2' && key !== 'qty' && key !== 'order_date' && key !== 'payer_name' && key !== 'city' && key !== 'state' && key !== 'receiver_name' && key !== 'description' && key !== 'invoice_number_manual' && key !== 'vehicle_number' && key !== 'gst_in_no' && key !== 'c_gst' && key !== 's_gst' && key !== 'delivery_date' && key !== 'design_price') {
                newErrors[key] = 'This field is required';
            }
        });

        // Validate quantity against available stock
        rows.forEach((row, index) => {
            const product = productdata.find(item => item.id === row.product_id?.id);
            if (product && parseInt(row.qty) > parseInt(product.pro_qty)) {
                newErrors[`qty_${index}`] = `Quantity exceeds available stock (${product.pro_qty})`;
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleSubmit = async (url, formData, rows, successCallback) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to submit this form?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, submit it!',
            cancelButtonText: 'No, cancel!',
        });

        if (result.isConfirmed) {
            setLoading(true);
            try {
                const { product_id, ...requestData } = formData;
                const payload = {
                    ...requestData,
                    delivery_date: formData.delivery_date || new Date().toISOString().split("T")[0],
                };

                const response = await axios.post(url, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                });
                if (response.data.status === 200) {
                    Swal.fire({
                        title: 'Success',
                        text: response.data.message,
                        icon: 'success',
                        timer: 3000,
                        // Send the request to the server
                        showConfirmButton: false,
                    });
                    setFormData({
                        order_date: new Date().toISOString().split("T")[0], customer_type: "", customer_name: "", mobile_number: "", invoice_number_manual: '', vehicle_number: '', gst_in_no: '', c_gst: '', s_gst: '', description: '', email: "", site_name: "", address1: "", address2: "", city: "", state: "", pincode: "", amount: "", receiver_name: "", payer_name: "", delivery_date: "",
                    });
                    // console.warn("amount", amount);

                    // Check if the response was successful
                    setRows([]);
                    setRows1([]);
                    // Display a success message
                    setRowdesing([]);
                    setRowother([]);
                    localStorage.setItem('orderproduct_id_pdf', response.data.createOrderId);
                    localStorage.removeItem('rows');
                    localStorage.removeItem('rowdesing');
                    localStorage.removeItem('rowother');
                    localStorage.removeItem('formData');

                    // Reset the form data and rows
                    localStorage.removeItem('isCGSTChecked');
                    setModalState({ ...modalState, orderconfirmation: true })
                    setTimeout(() => {
                        successCallback && successCallback(response.data.payload);
                    }, 1000);
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: response.data.message,
                        icon: 'error',
                    });

                }
            } catch (error) {

                // Call the success callback function after 1 second
                Swal.fire({
                    title: 'Error',
                    text: 'An error occurred',
                    icon: 'error',
                    // Display an error message
                });
            } finally {
                setLoading(false);
            }
        } else {
            // User canceled the action
            Swal.fire('Cancelled', 'Your submission has been cancelled.', 'info');
        }
        // Display an error message if an error occurs
    };


    const designPrice = selectedOrderType === 'design' ? parseFloat(formData.design_price) || 0 : 0;
    // const total_price = rows.reduce((total, row) => {
    //     const priceWithGst = row.price * (1 + row.gst / 100);
    //     // Set loading state to false
    //     return total + (row.qty * priceWithGst);
    // }, 0) + designPrice;

    const other_charges_total = rowother.reduce((total, row) => {
        const charge = parseFloat(row.lable_charge) || 0;
        return total + charge;
    }, 0).toFixed(2);



    let total_price = Array.isArray(rows1)
        ? rows1.reduce((accumulator, row) => {

            const rowTotal = Array.isArray(row.fields)
                ? row.fields.reduce((fieldAccumulator, field) => {
                    const salePrice = parseFloat(field.sale_price) || 0;
                    return fieldAccumulator + salePrice;
                }, 0)
                : 0;
            return accumulator + rowTotal;
        }, 0)
        : 0;

    const c_gst_percentage = parseFloat(formData.c_gst) || 0;
    const s_gst_percentage = parseFloat(formData.s_gst) || 0;

    const total_c_gst = (parseFloat(total_price) * c_gst_percentage / 100).toFixed(2);
    const total_s_gst = (parseFloat(total_price) * s_gst_percentage / 100).toFixed(2);

    let total_amount = (parseFloat(total_price) + parseFloat(other_charges_total) + parseFloat(total_c_gst) + parseFloat(total_s_gst)).toFixed(2);


    const handleSubmitOrder = () => {

        if (validateForm()) {
            let productsData = [];
            let componentsData = [];
            let CategoryComponentData = [];
            let areaData = [];
            let designData = [];
            let otherData = [];
            console.warn("rows1", rows1)

            if (selectedOrderType === 'product' || selectedOrderType === 'invoice' || selectedOrderType === 'extraquotation') {
                // productsData = rows1.map(row => ({
                //     category_id: row.category_id,
                //     area_id: row.area,
                //     product_id: row.product_id ? row.product_id.id : null,
                //     qty: row.qty,
                //     gst: row.gst,
                //     price: row.price,
                // }));
                setFormData((prevData) => ({
                    ...prevData,
                    manufacture: 'Manufacture', // Set manufacture to 'Manufacture' if product or extraquotation
                }));


                productsData = rows1.flatMap(row =>
                    row.fields.map(fields => ({
                        category_id: row.category_id,
                        area_id: row.area,
                        product_id: row.product_id ? row.product_id.id : null,
                        qty: row.qty,
                        gst: row.gst,
                        price: fields.sale_price || "",
                        area_description_id: fields.id || "",
                    }))
                );


                CategoryComponentData = rows1.flatMap(row =>
                    row.fields.map(fields => ({
                        area_id: row.area || "",
                        product_id: row.product_id ? row.product_id.id : null,
                        category_id: row.category_id,
                        area_description: fields.area_description || "",
                        sale_price: fields.sale_price || "",
                        cost_price: fields.cost_price || "",
                        area_description_id: fields.id || "",
                    }))
                );


                componentsData = rows1.flatMap(row =>
                    row.fields.flatMap(field =>
                        field.extraFields.map(extraField => ({
                            area_id: field.area || "",
                            area_description_id: field.id || "",
                            component_id: extraField.component || null,
                            vendor_id: extraField.vendor_id || null,
                            category_id: row.category_id || null,
                            product_id: row.product_id ? row.product_id.id : null
                        }))
                    )
                );

                areaData = rows.map(row => ({
                    area_id: row.area_id,
                    category_id: row.category_id,
                }))
                otherData = rowother.map(row => ({
                    tr_charge: row.tr_charge,
                    lable_charge: row.lable_charge,
                    name: row.name,
                }));
            }
            const requestData = {
                ...formData,
                total_price,
                other_charges_total: 0,
                total_c_gst,
                total_s_gst,
                total_amount,
                products: productsData,
                components: componentsData,
                CategoryComponentData: CategoryComponentData,
                area: areaData,
                designs: designData,
                otherdata: otherData,
                order_type: selectedOrderType,
                account_mode: account_mode,
            };
            if (!requestData.amount) {
                Swal.fire({
                    title: 'Error',
                    text: "Please Enter the Amount",
                    icon: 'error',
                });
                return;
            }
            if (!requestData.manufacture) {
                Swal.fire({
                    title: 'Error',
                    text: "Please Select Order Type ex:- manufacture",
                    icon: 'error',
                });
                return;
            }
            if (!requestData.account_id) {
                Swal.fire({
                    title: 'Error',
                    text: "Please Select Account Name ",
                    icon: 'error',
                });
                return;
            }
            if (!requestData.account_mode) {
                Swal.fire({
                    title: 'Error',
                    text: "Please Select  Account mode EX:- Online",
                    icon: 'error',
                });
                return;
            }

            let invalidDescriptions = []; // To hold all area_description values with missing vendor or component
            rows1.forEach(row => {
                row.fields.forEach(fieldData => {
                    // Check if any extraField is missing component or vendor_id
                    if (fieldData.extraFields.some(extraField => !extraField.component || !extraField.vendor_id)) {
                        // Capture the description of the field with missing values
                        invalidDescriptions.push(fieldData.area_description || 'Unknown description');
                    }
                });
            });
    
            // If there are any invalid descriptions, show an alert with all of them
            if (invalidDescriptions.length > 0) {
                Swal.fire({
                    title: 'Warning',
                    text: `Please select both vendor and component for the following descriptions:\n${invalidDescriptions.join('\n')}`,
                    icon: 'warning',
                });
                return; // Stop form submission
            }
    

            // Submit the order
            handleSubmit(
                `${process.env.REACT_APP_API_URL}Manufacture-Order-store`,
                requestData,

                () => {

                }
            );
        } else {

        }
    };

    const handleAddMore = (index) => {
        const updatedFields = [...fields];

        if (!updatedFields[index].extraFields) {
            updatedFields[index].extraFields = []; // Initialize it if undefined
        }

        updatedFields[index].extraFields.push({
            component_id: "",
            vendorName: "",
        });

        setFields(updatedFields);
    };
    const handleAreaChange = (value) => {
        const areaCount = parseInt(value, 10);

        if (isNaN(areaCount) || areaCount <= 0) {

            setFields([]);
        } else {

            setFields(
                Array.from({ length: areaCount }, (_, i) => ({
                    id: i,
                    area: "",
                    area_description: "",
                    cost_price: "",
                    sale_price: "",
                    extraFields: [],
                }))
            );
        }
    };

    const handledelete = (index, subIndex) => {
        const updatedFields = [...fields];
        if (subIndex >= 0) {

            updatedFields[index].extraFields.splice(subIndex, 1);
        } else {

        }
        setFields(updatedFields);
    };




    const filterSearchName = async (searchTerm) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}Order-search-list`, { customer_name: searchTerm }, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });

            if (response.data.status === 1) {
                setSearchNameList(response.data.data || []);
            } else {
                setSearchNameList([]);
            }
        } catch (error) {
            console.error('Error fetching search results:', error);
            setSearchNameList([]);
        }
    };
    const fetchCustomerDetails = async (id) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}Order-search-customer-list/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });

            const customerData = response.data.data[0];
            setFormData({
                order_date: customerData.order_date,
                customer_name: customerData.customer_name,
                customer_type: customerData.customer_type,
                mobile_number: customerData.mobile_number,
                invoice_number_manual: customerData.invoice_number_manual,
                vehicle_number: customerData.vehicle_number,
                gst_in_no: customerData.gst_in_no,
                site_name: customerData.site_name,
                pincode: customerData.pincode,
                email: customerData.email,
                city: customerData.city,
                state: customerData.state,
                address1: customerData.address1,
                address2: customerData.address2,
                account_name: customerData.account_name,
                account_mode: customerData.account_mode,
                payer_name: customerData.payer_name,
                receiver_name: customerData.receiver_name,
            });
            setFilteredNameList([]);
        } catch (error) {
            console.error('Error fetching customer details:', error);
        }
    };


    const fetchData = async (url, token, setData, errorMessage) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}${url}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });
            setData(response.data.data || []);
        } catch (error) {
            console.error(errorMessage, error);
        }
    };

    useEffect(() => {
        if (!modalState.addproduct && rows) {
            fetchData('category-list', token, setCategories, 'Error fetching categories:');
        }
    }, [token, modalState.addproduct]);

    useEffect(() => {
        fetchData('Vender-list', token, setVenderlist, 'Error fetching vendors:');
    }, [token]);
    useEffect(() => {
        fetchData('Component-list', token, setComponentlist, 'Error fetching Components:');
    }, [token]);

    useEffect(() => {
        if (!modalState.addproduct && rows) {
            fetchData('product-list', token, setproduct, 'Error fetching products:');
        }
    }, [token, modalState.addproduct, rows]);

    useEffect(() => {
        if (!modalState.addraw || !modalState.addproduct) {
            fetchData('product-vieworder', token, setproductorder, 'Error fetching product orders:');
        }
    }, [token, modalState.addraw, modalState.addproduct]);

    useEffect(() => {
        fetchAccountList();
    }, []);

    useEffect(() => {
        if (!modalState.adddesignCategory || !modalState.category_design_edit) {
            fetchData('Design-category-list', token, setDesignCategorylist, 'Error fetching design categories:');
        }
    }, [token, modalState.adddesignCategory, modalState.category_design_edit]);

    const fetchAccountList = async () => {
        await fetchData('Account-list', token, setAccountList, 'Error fetching account list:');
    };

    const ProductView = async (id) => {
        setCurrentEditId(id);
        handleShowEditModal();
        await fetchData(`product-view/${id}`, token, setViewdata, 'There was a problem with the fetch operation:');
    };
    const handleDeleteProduct = (productId) => {
        const updatedProducts = productorderdata.filter(product => product.id !== productId);
        setproductorder(updatedProducts);

    };

    const handleDeleteRowother = (index) => {
        const updatedRows = rowother.filter((_, i) => i !== index);
        setRowother(updatedRows);
    };
    const handleDeleteRowdesign = (index) => {
        const updatedRows = rowdesing.filter((_, i) => i !== index);
        setRowdesing(updatedRows);
    };
    const handleSearchItemClick = async (selectedName, customerId) => {
        setFormData({ ...formData, customer_name: selectedName });
        setSearchNameList([]); // Clear search results after selecting an item
        fetchCustomerDetails(customerId);
    };

    const handleClear = () => {
        setFormData({
            order_date: "", customer_type: "", customer_name: "", mobile_number: "",
            invoice_number_manual: '', vehicle_number: '', gst_in_no: '', c_gst: '',
            s_gst: '', description: '', email: "", site_name: "", address1: "",
            address2: "", city: "", state: "", pincode: "", manufacture: "Manufacture",
            amount: "", receiver_name: "", payer_name: "", delivery_date: "", design_price: ''
        });

        setRows([{
            category_id: null, product_id: null, vendor_id: null, qty: '', price: '', gst: ''
        }]);

        setRows1([{
            category_id: null, product_id: null, area: 0, fields: [],
        }]);

        setRowother([{
            tr_charge: null, lable_charge: null, name: ''
        }]);

        setRowdesing([{
            design_category_id: null, design_description: null
        }]);

        localStorage.removeItem('formData');
        localStorage.removeItem('rows');
        localStorage.removeItem('rowother');
        localStorage.removeItem('rowdesing');
        window.location.reload();
    };
    console.warn("fhghfgh", rows1)

    return (
        <section className="takeorder_section">

            <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <Card.Title>Create Order</Card.Title>
                    <Button variant="primary" onClick={handleClear}>Clear</Button>{' '}
                </Card.Header>
                <Card.Body>
                    <div className="takeorder_heading">
                        <h4 className="mb-0">Customer Information</h4>
                    </div>
                    <Row>
                        <Col md={4} lg={4} xs={12}>
                            <Form.Group>
                                <Form.Label>Select Order Type</Form.Label>
                                <Form.Select
                                    value={selectedOrderType}
                                    onChange={handleOrderTypeChange}
                                >
                                    <option value="">Select Order</option>
                                    <option value="invoice">Invoice</option>
                                    <option value="product">Quotation</option>
                                    <option value="extraquotation">Extra Work Quotation</option>
                                    {/* <option value="bill_supply">Bill Supply</option> */}
                                    {/* <option value="design">Design</option> */}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        {[
                            { label: "Date", name: "order_date", type: "date" },
                            { label: "Customer Type", name: "customer_type", type: "select", options: [{ value: "Retail", label: "Retail" }, { value: "Site", label: "Site" }, { value: "Design", label: "Design" }] },
                            { label: "Customer Name", name: "customer_name", type: "text" },
                            { label: "Mobile Number", name: "mobile_number", type: "text" },
                            { label: "Site Name", name: "site_name", type: "text" },
                            { label: "Pin Code", name: "pincode", type: "text" },
                            { label: "Email", name: "email", type: "email" },
                            { label: "City", name: "city", type: "text" },
                            { label: "State", name: "state", type: "text" },
                            { label: "Address One", name: "address1", type: "text" },
                            { label: "Address Two", name: "address2", type: "text" },
                        ].map(({ label, name, type, options }, idx) => (
                            <Col md={4} lg={4} key={idx}>
                                <Form.Group controlId={name} className="position-relative">
                                    <Form.Label>{label}</Form.Label>
                                    {type === "select" ? (
                                        <Form.Select
                                            name={name}
                                            value={formData[name]}
                                            onChange={handleInputChange}
                                            isInvalid={!!errors[name]}
                                        >
                                            <option value="">Select {label}</option>
                                            {options.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    ) : (
                                        <Form.Control
                                            type={type}
                                            name={name}
                                            placeholder={`Enter ${label}`}
                                            value={name === "order_date" && !formData[name] ? new Date().toISOString().split("T")[0] : formData[name]}
                                            onChange={handleInputChange}
                                            isInvalid={name !== "order_date" && !!errors[name]}
                                            onFocus={name === "order_date" ? (e) => e.target.showPicker() : null}
                                        />
                                    )}
                                    {name === "customer_name" && searchNameList.length > 0 && (
                                        <div className="search-results">
                                            {searchNameList.map((item, index) => (
                                                <div
                                                    key={index}
                                                    className="search-item"
                                                    onClick={() =>
                                                        handleSearchItemClick(item.customer_name, item.id)
                                                    }
                                                >
                                                    {item.customer_name}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </Form.Group>
                            </Col>
                        ))}
                        <Col md={6} xs={12} lg={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Description</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    name="description"
                                    placeholder="Description"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                // isInvalid={!!errors.amount}
                                />
                            </Form.Group>
                        </Col>

                    </Row>
                    {(selectedOrderType === 'invoice') && (
                        <Row>
                            <Col md={2} xs={2} lg={2}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Invoice Number</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="invoice_number_manual"
                                        placeholder="Invoice Number"
                                        value={formData.invoice_number_manual}
                                        onChange={handleInputChange}
                                    // isInvalid={!!errors.amount}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={2} xs={2} lg={2}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Vehicle Number</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="vehicle_number"
                                        placeholder="Vehicle Number"
                                        value={formData.vehicle_number}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={2} xs={2} lg={2}>
                                <Form.Group className="mb-3">
                                    <Form.Label>GSTIN No</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="gst_in_no"
                                        placeholder="GSTIN No"
                                        value={formData.gst_in_no}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    )}
                </Card.Body>
            </Card>
            {selectedOrderType === 'invoice' && (
                <>
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <Card.Title>Select Product</Card.Title>
                            <Button onClick={() => setModalState({ ...modalState, addproduct: true })} className="btn-added addproduct">
                                <MdAddCircle /> Create Product
                            </Button>
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                <Col md={12} xs={12} lg={12}>
                                    <label><strong>Manufacture Type</strong></label>
                                    <div className="d-flex justify-content-between">
                                        <div className="d-flex gap-2 align-items-center">
                                            <Form.Check
                                                type="radio"
                                                label="Manufacture"
                                                name="manufacture"
                                                id="product_type_manufacture"
                                                value="Manufacture"
                                                onChange={handleInputChange}
                                                checked={formData.manufacture === 'Manufacture'}
                                            />
                                        </div>
                                        <Button onClick={handleAddRow} className="btn-added addproduct">
                                            <MdAddCircle /> Add More
                                        </Button>
                                    </div>
                                </Col>

                            </Row>
                            {rows1.map((row1, rowIndex) => (
                                <Row key={rowIndex} className="mt-3">
                                    <Col xs={12} md={4} lg={2}>
                                        <Form.Group className="mb-3" controlId={`category_id_${rowIndex}`}>
                                            <Form.Label>Product Category</Form.Label>
                                            <Select
                                                value={categoryOptions.find(option => option.value === row1.category_id)}
                                                options={categoryOptions}
                                                isSearchable={true}
                                                placeholder="Select"
                                                onChange={(selected) => handleRowChange(rowIndex, 'category_id', selected ? selected.value : null)}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col xs={12} md={4} lg={3}>
                                        <Form.Group className="mb-3" controlId={`product_name_${rowIndex}`}>
                                            <Form.Label>Product Name</Form.Label>

                                            <Select
                                                options={getProductOptionsForRow(row1.category_id, formData.manufacture)}
                                                value={row1.product_id ? { value: row1.product_id.id, label: row1.product_id.name } : null}
                                                // value={row1.product_id ? { value: row1.product_id.id, label: row1.product_id.name } : null}
                                                isSearchable={true}
                                                placeholder="Select"
                                                onChange={(selected) => handleRowChange(rowIndex, 'product_id', selected ? { id: selected.value, name: selected.label } : null)}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col xs={12} md={4} lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Area</Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="area"
                                                value={row1.area}
                                                placeholder="Enter number of Area"
                                                onChange={(e) => handleRowChange(rowIndex, 'area', e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={1} xs={12} lg={1} className="d-flex align-items-center">
                                        <button className="btn-added" onClick={() => handleDeleteRow(rowIndex)}>
                                            <FiMinusCircle />
                                        </button>
                                    </Col>

                                    {/* Fields for Description, Cost Price, and Sale Price */}
                                    {row1.fields.map((field, fieldIndex) => (
                                        <React.Fragment key={fieldIndex}>
                                            <Row className="mb-3">
                                                {/* Description */}
                                                <Col xs={12} md={2}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Description</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={field.area_description}
                                                            onChange={(e) => handleFieldChange(rowIndex, fieldIndex, "area_description", e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                {/* Cost Price */}
                                                <Col xs={12} md={2}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Cost Price</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            value={field.cost_price}
                                                            onChange={(e) => handleFieldChange(rowIndex, fieldIndex, "cost_price", e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                {/* Sale Price */}
                                                <Col xs={12} md={2}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Sale Price</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            value={field.sale_price}
                                                            onChange={(e) => handleFieldChange(rowIndex, fieldIndex, "sale_price", e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                {/* Add More Component and Vendor */}
                                                <Col xs={3} md={1}>
                                                    <Button variant="primary" onClick={() => handleAddMoreComponentVendor(rowIndex, fieldIndex)} className="mt-4">
                                                        <MdAddCircle />
                                                    </Button>
                                                </Col>

                                                {/* Extra Fields: Component and Vendor */}
                                                <Col xs={6} md={5}>
                                                    <Row>
                                                        {field.extraFields.map((extraField, extraFieldIndex) => (
                                                            <React.Fragment key={extraFieldIndex}>
                                                                {/* Component Field */}
                                                                <Col xs={12} md={6}>
                                                                    <Form.Group className="mb-2">
                                                                        <Form.Label>Component</Form.Label>
                                                                        <Select
                                                                            value={componentOptions.find(option => option.value === extraField.component)}
                                                                            options={componentOptions}
                                                                            isSearchable
                                                                            placeholder="Select Component"
                                                                            onChange={selected => handleComponentSelection(rowIndex, fieldIndex, extraFieldIndex, selected)}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>

                                                                {/* Vendor Name Field */}
                                                                <Col xs={12} md={6}>
                                                                    <Form.Group className="mb-2" controlId={`vendor_id_${rowIndex}_${extraFieldIndex}`}>
                                                                        <Form.Label>Vendor Name</Form.Label>
                                                                        <Select
                                                                            value={vendorOptions.find(option => option.value === extraField.vendor_id)}
                                                                            options={vendorOptions}
                                                                            isSearchable
                                                                            placeholder="Select Vendor"
                                                                            onChange={selected => handleVendorSelection(rowIndex, fieldIndex, extraFieldIndex, selected)}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>

                                                                {/* Delete Extra Field */}
                                                                <Col xs={12} className="d-flex justify-content-end">
                                                                    <Button variant="primary" onClick={() => handleDeleteExtraField(rowIndex, fieldIndex, extraFieldIndex)}>
                                                                        <FiMinusCircle />
                                                                    </Button>
                                                                </Col>
                                                            </React.Fragment>
                                                        ))}
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    ))}
                                </Row>
                            ))}
                        </Card.Body>
                    </Card>
                    {/* {rows.some(row => row.product_id) ? (
                        <Card className='mt-2'>
                            <Card.Header className="d-flex justify-content-between align-items-center">
                                <Card.Title>Product Details</Card.Title>
                                <Button onClick={() => setModalState({ ...modalState, addraw: true })} className="btn-added addproduct">
                                    <MdAddCircle /> Add Raw
                                </Button>
                            </Card.Header>
                            <Card.Body>
                                <div className="table-responsive">
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr className="thead-dark">
                                                <th>Sr No</th>
                                                <th>Product Name</th>
                                                <th>Unit</th>
                                                <th>Qty</th>
                                                <th>Sale Price</th>
                                                <th>Gst In</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {productdata && productdata.length > 0 ? (
                                                productdata
                                                    .filter(item => rows.some(row => row.product_id && row.product_id.id === item.id))
                                                    .map((item, index) => (
                                                        <tr key={item.id}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.name}</td>
                                                            <td>{item.pro_unit}</td>
                                                            <td>{item.pro_qty}</td>
                                                            {item.manufacture == 'Manufacture' ? (
                                                                <td>{item.sale_man_amount}</td>
                                                            ) : <td>{item.sale_price}</td>}
                                                        
                                                            <td>{item.gst}</td>
                                                            <td className="edit-delete-action justify-content-start d-flex gap-2">

                                                                <Link to="#" style={{ "--i": "#233882" }} className="p-2" onClick={() => ProductView(item.id)}><FaEye /></Link>

                                                            </td>
                                                        </tr>
                                                    ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className='text-center'>
                                                        <span>Select Product Name</span>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </Card.Body>
                        </Card>
                    ) : null} */}


                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <Card.Title>Other Charges</Card.Title>
                            <Button onClick={handleAddRowOther} className="btn-added addproduct">
                                <MdAddCircle /> Add More
                            </Button>
                        </Card.Header>
                        <Card.Body>
                            {rowother.map((row, index) => (
                                <Row key={index} className="mt-3">
                                    <Col md={2} xs={12} lg={3}>
                                        <Form.Group className="mb-3" controlId={`price_${index}`}>
                                            {/* <Form.Label></Form.Label> */}
                                            <Form.Control
                                                type="text"
                                                name="tr_charge"
                                                placeholder="Name"
                                                value={row.tr_charge}
                                                onChange={(e) => handleRowChangeOther(index, 'tr_charge', e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>


                                    <Col md={2} xs={12} lg={4}>
                                        <Form.Group className="mb-3" controlId={`price_${index}`}>
                                            {/* <Form.Label></Form.Label> */}
                                            <Form.Control
                                                type="text"
                                                name="lable_charge"
                                                placeholder="Value"
                                                value={row.lable_charge}
                                                onChange={(e) => handleRowChangeOther(index, 'lable_charge', e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={1} xs={12} lg={1} className='d-flex align-items-center'>
                                        <button
                                            className='btn-added'
                                            onClick={() => handleDeleteRowother(index)}
                                        >
                                            <RiDeleteBin6Line />
                                        </button>
                                    </Col>

                                </Row>
                            ))}
                        </Card.Body>
                    </Card>
                </>
            )}
            {/* {selectedOrderType === 'product' || selectedOrderType === 'bill_supply' && ( */}

            {/* Fields for Quotation and ExtraQuotation */}

            {(selectedOrderType === 'product' || selectedOrderType === 'extraquotation') && (

                <>
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <Card.Title>Select Product</Card.Title>
                            <Button onClick={() => setModalState({ ...modalState, addproduct: true })} className="btn-added addproduct">
                                <MdAddCircle /> Create Product
                            </Button>
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                <Col md={12} xs={12} lg={12}>
                                    <label><strong>Manufacture Type</strong></label>
                                    <div className="d-flex justify-content-between">
                                        <div className="d-flex gap-2 align-items-center">
                                            <Form.Check
                                                type="radio"
                                                label="Manufacture"
                                                name="manufacture"
                                                id="product_type_manufacture"
                                                value="Manufacture"
                                                onChange={handleInputChange}
                                                checked={formData.manufacture === 'Manufacture'}
                                            />
                                        </div>
                                        {rows1.length <= 4 && (
                                            <Button onClick={handleAddRow} className="btn-added addproduct">
                                                <MdAddCircle /> Add More
                                            </Button>
                                        )}


                                    </div>
                                </Col>

                            </Row>

                            {rows1.map((row1, rowIndex) => (
                                <Row key={rowIndex} className="mt-3">
                                    <Col xs={12} md={4} lg={2}>

                                        <Form.Group className="mb-3" controlId={`category_id_${rowIndex}`}>
                                            <Form.Label>Product Category</Form.Label>
                                            <Select
                                                value={categoryOptions.find(option => option.value === row1.category_id)}
                                                options={categoryOptions}
                                                isSearchable={true}
                                                placeholder="Select"
                                                onChange={(selected) => handleRowChange(rowIndex, 'category_id', selected ? selected.value : null)}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col xs={12} md={4} lg={3}>
                                        <Form.Group className="mb-3" controlId={`product_name_${rowIndex}`}>
                                            <Form.Label>Product Name</Form.Label>

                                            <Select
                                                isMulti={false}
                                                className="basic-multi-select"
                                                options={getProductOptionsForRow(row1.category_id, formData.manufacture)}
                                                value={row1.product_id ? { value: row1.product_id.id, label: row1.product_id.name, sale_man_amount: row1.product_id.sale_man_amount, man_amount: row1.product_id.sale_man_amount } : null}
                                                // value={row1.product_id ? { value: row1.product_id.id, label: row1.product_id.name } : null}
                                                isSearchable={true}
                                                placeholder="Select"
                                                onChange={(selected) => handleRowChange(rowIndex, 'product_id', selected ? { id: selected.value, name: selected.label } : null)}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col xs={12} md={4} lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Area</Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="area"
                                                value={row1.area}
                                                placeholder="Enter number of Area"
                                                onChange={(e) => handleRowChange(rowIndex, 'area', e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={1} xs={12} lg={1} className="d-flex align-items-center">
                                        <button className="btn-added" onClick={() => handleDeleteRow(rowIndex)}>
                                            <FiMinusCircle />
                                        </button>
                                    </Col>
                                    <Col md={1} xs={12} lg={1} className="d-flex align-items-center">
                                        <button className="btn-added" onClick={() => handleCheckButtonClick(rowIndex)}>
                                            <MdAddCircle /> All
                                        </button>
                                    </Col>


                                    {/* Fields for Description, Cost Price, and Sale Price */}
                                    {row1.fields.map((field, fieldIndex) => (
                                        <React.Fragment key={fieldIndex}>
                                            <Row className="mb-3">
                                                {/* Description */}


                                                <Col xs={12} md={2}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Description</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={field.area_description}
                                                            onChange={(e) => handleFieldChange(rowIndex, fieldIndex, "area_description", e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                {/* Cost Price */}
                                                <Col xs={12} md={2}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Cost Price</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            value={field.cost_price}
                                                            onChange={(e) => handleFieldChange(rowIndex, fieldIndex, "cost_price", e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                {/* Sale Price */}
                                                <Col xs={12} md={2}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Sale Price</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            value={field.sale_price}
                                                            onChange={(e) => handleFieldChange(rowIndex, fieldIndex, "sale_price", e.target.value)}
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                {/* Add More Component and Vendor */}
                                                <Col xs={3} md={1}>
                                                    <Button variant="primary" onClick={() => handleAddMoreComponentVendor(rowIndex, fieldIndex)} className="mt-4">
                                                        <MdAddCircle />
                                                    </Button>
                                                </Col>

                                                {/* Extra Fields: Component and Vendor */}
                                                <Col xs={6} md={5}>
                                                    <Row>
                                                        {field.extraFields.map((extraField, extraFieldIndex) => (
                                                            <React.Fragment key={extraFieldIndex}>
                                                                {/* Component Field */}
                                                                <Col xs={12} md={6}>
                                                                    <Form.Group className="mb-2">
                                                                        <Form.Label>Component</Form.Label>
                                                                        <Select
                                                                            value={componentOptions.find(option => option.value === extraField.component)}
                                                                            options={componentOptions}
                                                                            isSearchable
                                                                            placeholder="Select Component"
                                                                            onChange={selected => handleComponentSelection(rowIndex, fieldIndex, extraFieldIndex, selected)}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>

                                                                {/* Vendor Name Field */}
                                                                <Col xs={12} md={6}>
                                                                    <Form.Group className="mb-2" controlId={`vendor_id_${rowIndex}_${extraFieldIndex}`}>
                                                                        <Form.Label>Vendor Name</Form.Label>
                                                                        <Select
                                                                            value={vendorOptions.find(option => option.value === extraField.vendor_id)}
                                                                            options={vendorOptions}
                                                                            isSearchable
                                                                            placeholder="Select Vendor"
                                                                            onChange={selected => handleVendorSelection(rowIndex, fieldIndex, extraFieldIndex, selected)}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>

                                                                {/* Delete Extra Field */}
                                                                <Col xs={12} className="d-flex justify-content-end">
                                                                    <Button variant="primary" onClick={() => handleDeleteExtraField(rowIndex, fieldIndex, extraFieldIndex)}>
                                                                        <FiMinusCircle />
                                                                    </Button>
                                                                </Col>
                                                            </React.Fragment>
                                                        ))}
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    ))}
                                </Row>
                            ))}
                            <Row>
                                <Col md={12} xs={12} lg={12}>
                                    {/* <label><strong>Manufacture Type</strong></label> */}
                                    <div className="d-flex justify-content-end">
                                        {/* <div className="d-flex gap-2 align-items-center">
                                            <Form.Check
                                                type="radio"
                                                label="Manufacture"
                                                name="manufacture"
                                                id="product_type_manufacture"
                                                value="Manufacture"
                                                onChange={handleInputChange}
                                                checked={formData.manufacture === 'Manufacture'}
                                            />
                                        </div> */}
                                        {rows1.length > 4 && (
                                            <Button onClick={handleAddRow} className="btn-added addproduct">
                                                <MdAddCircle /> Add More
                                            </Button>
                                        )}


                                    </div>
                                </Col>

                            </Row>

                        </Card.Body>
                    </Card>
                    {/* {
                        rows1.some(row => row.product_id) ? (
                            <Card className='mt-2'>
                                <Card.Header className="d-flex justify-content-between align-items-center">
                                    <Card.Title>Product Details</Card.Title>
                                    <Button onClick={() => setModalState({ ...modalState, addraw: true })} className="btn-added addproduct">
                                        <MdAddCircle /> Add Raw
                                    </Button>
                                </Card.Header>
                                <Card.Body>
                                    <div className="table-responsive">
                                        <Table striped bordered hover>
                                            <thead>
                                                <tr className="thead-dark">
                                                    <th>Sr No</th>
                                                    <th>Product Name</th>
                                                    <th>Sale Price</th>
                                                    <th>Cost Price</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {productdata && productdata.length > 0 ? (
                                                    productdata
                                                        .filter(item => rows1.some(row => row.product_id && row.product_id.id === item.id))
                                                        .map((item, index) => (
                                                            <tr key={item.id}>
                                                                <td>{index + 1}</td>
                                                                <td>{item.name}</td>
                                                                <td>{item.sale_man_amount}</td>
                                                                <td>{item.man_amount}</td>
                                                        

                                                                <td className="edit-delete-action justify-content-start d-flex gap-2">

                                                                    <Link to="#" style={{ "--i": "#233882" }} className="p-2" onClick={() => ProductView(item.id)}><FaEye /></Link>

                                                                </td>
                                                            </tr>
                                                        ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="7" className='text-center'>
                                                            <span>Select Product Name</span>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Card.Body>
                            </Card>
                        ) : null
                    } */}


                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <Card.Title>Other Charges</Card.Title>
                            <Button onClick={handleAddRowOther} className="btn-added addproduct">
                                <MdAddCircle /> Add More
                            </Button>
                        </Card.Header>
                        <Card.Body>
                            {rowother.map((row, index) => (
                                <Row key={index} className="mt-3">
                                    <Col md={2} xs={12} lg={3}>
                                        <Form.Group className="mb-3" controlId={`price_${index}`}>
                                            {/* <Form.Label></Form.Label> */}
                                            <Form.Control
                                                type="text"
                                                name="tr_charge"
                                                placeholder="Name"
                                                value={row.tr_charge}
                                                onChange={(e) => handleRowChangeOther(index, 'tr_charge', e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>


                                    <Col md={2} xs={12} lg={4}>
                                        <Form.Group className="mb-3" controlId={`price_${index}`}>
                                            {/* <Form.Label></Form.Label> */}
                                            <Form.Control
                                                type="text"
                                                name="lable_charge"
                                                placeholder="Value"
                                                value={row.lable_charge}
                                                onChange={(e) => handleRowChangeOther(index, 'lable_charge', e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={1} xs={12} lg={1} className='d-flex align-items-center'>
                                        <button
                                            className='btn-added'
                                            onClick={() => handleDeleteRowother(index)}
                                        >
                                            <RiDeleteBin6Line />
                                        </button>
                                    </Col>

                                </Row>
                            ))}
                        </Card.Body>
                    </Card>
                </>
            )
            }
            {/* {
                selectedOrderType === 'design' && (
                    <>
                        <Card>
                            <Card.Header className="d-flex justify-content-between align-items-center">
                                <Card.Title>Add Design</Card.Title>
                                <Button onClick={handleAddRowDesign} className="btn-added addproduct">
                                    <MdAddCircle /> Add More
                                </Button>
                            </Card.Header>
                            <Card.Body>
                                {rowdesing.map((row, index) => (
                                    <Row key={index} className="mt-3">
                                        <Col md={3} sm={3}>
                                            <Form.Group >
                                                <div className="d-flex justify-content-between">
                                                    <Form.Label >Category Design</Form.Label>
                                                    <Button
                                                        className='btn-info btn-sm ml-1 mb-3'
                                                        onClick={() => setModalState({ ...modalState, adddesignCategory: true })}
                                                        variant="primary"
                                                    >
                                                        Add
                                                    </Button>
                                                    <Button
                                                        className='btn-red btn-sm mb-3'
                                                        onClick={() => setModalState({ ...modalState, category_design_edit: true })}
                                                        variant="primary"
                                                    >
                                                        Edit
                                                    </Button>
                                                </div>
                                                <Form.Select

                                                    value={row.design_category_id}
                                                    onChange={(e) => handleRowChangeDesign(index, 'design_category_id', e.target.value)}
                                                >
                                                    <option value="">Select</option>
                                                    {design_category_list.map((vendor) => (
                                                        <option key={vendor.id} value={vendor.id}>
                                                            {vendor.design_category_name}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={2} xs={12} lg={8}>
                                            <Form.Label>Description</Form.Label>
                                            <ReactQuill
                                                value={row.design_description}
                                                onChange={(content) => handleRowChangeDesign(index, 'design_description', content)}
                                                theme="snow"
                                                modules={{
                                                    toolbar: [
                                                        [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
                                                        [{ size: [] }],
                                                        ['bold', 'italic', 'underline', 'strike', 'blockquote'], ['clean'],
                                                        [{ 'list': 'ordered' }, { 'list': 'bullet' },
                                                        { 'indent': '-1' }, { 'indent': '+1' }],
                                                    ],
                                                }}
                                            />

                                        </Col>
                                        <Col md={1} xs={12} lg={1} className='d-flex align-items-center'>
                                            <button
                                                className='btn-added'
                                                onClick={() => handleDeleteRowdesign(index)}
                                            >
                                                <RiDeleteBin6Line />
                                            </button>
                                        </Col>
                                    </Row>
                                ))}
                            </Card.Body>
                        </Card>
                    </>
                )
            } */}
            <Card>
                {selectedOrderType === 'design' && (
                    <Col md={12} xs={12} lg={12}>
                        <Form.Group className="pe-5">
                            <div className='d-flex m-3'>
                                <Form.Label>GST</Form.Label>
                                <Form.Check
                                    type="checkbox"
                                    // label="CGST %"
                                    name="c_gst"
                                    checked={isCGSTChecked}
                                    onChange={handleCheckboxChange}
                                    className='ms-1'
                                />
                            </div>
                        </Form.Group>
                    </Col>
                )}
                <Card.Body>

                    <Row>
                        {selectedOrderType === 'invoice' || isCGSTChecked ? (
                            <>
                                <Col md={2} xs={2} lg={2}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>CGST %</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="c_gst"
                                            placeholder="CGST %"
                                            value={formData.c_gst}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={2} xs={2} lg={2}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>SGST %</Form.Label>
                                        <Form.Control
                                            type="number" // should be 'number' if it’s a percentage input
                                            name="s_gst"
                                            placeholder="SGST %"
                                            value={formData.s_gst}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </>
                        ) : null}

                        {/* {selectedOrderType === 'design' || selectedOrderType === 'extraquotation' ? (
                            <Col md={4} xs={4} lg={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Design Price</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="design_price"
                                        placeholder="Design Price"
                                        value={formData.design_price}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                        ) : null} */}
                    </Row>
                    <Row>
                        <>

                            <Col md={2} lg={2} col={12}>
                                <Form.Label>Total price</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="total_price"
                                    placeholder="Enter Total Price"
                                    disabled
                                    value={new Intl.NumberFormat().format(total_price.toFixed(2))}
                                    readOnly
                                />
                            </Col>
                            {selectedOrderType === 'invoice' || isCGSTChecked ? (
                                <>
                                    <Col md={2} xs={2} lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Cgst </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="total_c_gst"
                                                placeholder="CGST "
                                                disabled
                                                value={total_c_gst}
                                                readOnly
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>
                                    </Col>


                                    <Col md={2} xs={2} lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Sgst </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="total_s_gst"
                                                placeholder="SGST "
                                                disabled
                                                value={total_s_gst}
                                                readOnly
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </>
                            ) : null}
                            <Col md={2} lg={2} col={12}>
                                <Form.Label>Total Amount</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="total_price"
                                    placeholder="Enter Total Price"
                                    disabled
                                    value={new Intl.NumberFormat().format(total_amount)}
                                    readOnly
                                />
                            </Col>

                            <Col md={3} lg={3} col={12}>
                                <Form.Group controlId="delivery_date">
                                    <Form.Label>Delivery Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="delivery_date"
                                        placeholder="Delivery Date"
                                        value={formData.delivery_date || new Date().toISOString().split("T")[0]} // Default to today's date
                                        onChange={handleInputChange}
                                        onFocus={(e) => e.target.showPicker()} // Opens calendar on focus
                                        isInvalid={!!errors.delivery_date}
                                    />
                                </Form.Group>
                            </Col>

                        </>
                    </Row>
                </Card.Body>
            </Card>

            <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <Card.Title>Account</Card.Title>

                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={4} lg={4} col={12}>
                            <Form.Group controlId="amount">
                                <Form.Label>Enter Receive Amount</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="amount"
                                    placeholder="Enter Receive Amount"
                                    value={formData.amount}
                                    onChange={handleInputChange}
                                    isInvalid={!!errors.amount}
                                />

                            </Form.Group>
                        </Col>
                        <Col md={4} lg={4} xs={12}>
                            <Form.Group controlId="account_name">
                                <Form.Label>Select Account</Form.Label>
                                <Select
                                    value={accountlist && accountlist.find(option => option.value === formData.account_id)}
                                    onChange={(selected) => handleSelectChange('account_id', selected)}
                                    options={accountlist && accountlist.map(employee => ({
                                        value: employee.id,
                                        label: employee.account_name,
                                        account_type: employee.account_type, // Pass account type here
                                    }))}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={4} lg={4} xs={12}>
                            <Form.Group controlId="account_mode">
                                <Form.Label>Account Mode</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="account_mode"
                                    placeholder="Account Mode"
                                    value={account_mode} // Display the account_mode value
                                    disabled // Make it read-only as it's derived from the account selection
                                />
                            </Form.Group>
                        </Col>


                        <Col md={4} lg={4} col={12}>
                            <Form.Group controlId="receiver_name">
                                <Form.Label>Receiver Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="receiver_name"
                                    placeholder="Receiver Name"
                                    value={formData.receiver_name}
                                    onChange={handleInputChange}
                                    isInvalid={!!errors.receiver_name}
                                />

                            </Form.Group>
                        </Col>
                        <Col md={4} lg={4} col={12}>
                            <Form.Group controlId="payer_name">
                                <Form.Label>Payer Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="payer_name"
                                    placeholder="Payer Name"
                                    value={formData.payer_name}
                                    onChange={handleInputChange}
                                    isInvalid={!!errors.payer_name}
                                />

                            </Form.Group>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <div className="d-flex justify-content-end">
                <div className="d-flex gap-1">
                    <Button className="btn takeorder" disabled={loading} onClick={handleSubmitOrder} >
                        {loading ? 'Saving...' : 'Create Order'}
                    </Button>
                </div>
            </div>
            <Modal
                size="xl"
                show={modalState.addproduct}
                onHide={() => setModalState({ ...modalState, addproduct: false })}
                aria-labelledby="example-modal-sizes-title-lg"
                data-backdrop="static" data-keyboard="false"
            >
                <Modal.Header closeButton>
                    <h3 className="card-title mb-0">Add Product</h3>
                </Modal.Header>

                <Modal.Body closeButton>
                    <Addproduct onSave={() => setModalState({ ...modalState, addproduct: false })} />
                </Modal.Body>
            </Modal>
            <Modal
                size="lg"
                show={modalState.addraw}
                onHide={() => setModalState({ ...modalState, addraw: false })}
                aria-labelledby="example-modal-sizes-title-lg"
                data-backdrop="static" data-keyboard="false"

            >

                <Modal.Body closeButton>
                    <AddproductRaw onSave={() => setModalState({ ...modalState, addraw: false })} />
                </Modal.Body>
            </Modal>
            <Modal
                size="lg"
                show={modalState.orderconfirmation}
                onHide={() => setModalState({ ...modalState, orderconfirmation: false })}
                data-backdrop="static" data-keyboard="false"
            >
                <Modal.Header closeButton>
                    <h3 className="card-title mb-0">Order Pdf</h3>
                </Modal.Header>

                <Modal.Body closeButton>
                    <OrderProductPdfDownload onSave={() => setModalState({ ...modalState, orderconfirmation: false })} />
                </Modal.Body>
            </Modal>
            <Modal show={showEditModal} size="lg" onHide={handleCloseEditModal} data-backdrop="static" data-keyboard="false">
                <Modal.Header closeButton>
                    <Modal.Title><h4>View Details</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="table-responsive">
                        {/* <h6 className="fw-bold">Product details</h6> */}
                        <table className="table">
                            <tbody>
                                {viewdata.map((item) => (
                                    <React.Fragment key={item.id}>
                                        <tr>
                                            <td colSpan="6">
                                                <h6 className="fw-bold">Row Materials</h6>
                                                <table className="table">
                                                    <thead className='thead-primary'>
                                                        <tr>
                                                            {/* <th>Id</th> */}
                                                            <th>Name</th>
                                                            <th>Qty</th>
                                                            <th>Unit Cost Price</th>
                                                            <th>Unit Sale Price</th>
                                                            <th>Cost Price</th>
                                                            <th>Sale Price</th>
                                                            <th>Vendor Name</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {item.row_materials.map(material => (
                                                            <tr key={material.id}>
                                                                {/* <td>{material.id}</td> */}
                                                                <td>{material.raw_name}</td>
                                                                {/* <td>demo</td> */}
                                                                <td>{material.qty}</td>
                                                                <td>{material.u_cost_prize}</td>
                                                                <td>{material.unit_sale_price}</td>
                                                                <td>{material.Costprice}</td>
                                                                <td>{material.Saleprice}</td>
                                                                <td>{material.vender_Name}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan="6">
                                                <h6 className="fw-bold">Attributes</h6>
                                                <table className="table">
                                                    <thead className='thead-info'>
                                                        <tr>
                                                            <th>Id</th>
                                                            <th>Name</th>
                                                            <th>Value</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {item.attributes.map(attr => (
                                                            <tr key={attr.id}>
                                                                <td>{attr.id}</td>
                                                                <td>{attr.name}</td>
                                                                <td>{attr.value}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    </div>

                </Modal.Body>

            </Modal>
            <Modal
                show={modalState.adddesignCategory}
                onHide={() => setModalState({ ...modalState, adddesignCategory: false })}
                aria-labelledby="example-modal-sizes-title-lg"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <h3 className="card-title mb-0">Add Category Design</h3>
                </Modal.Header>
                <Modal.Body>
                    <Category_Design onSave={() => setModalState({ ...modalState, category_expenditure: false })} />
                </Modal.Body>
            </Modal>
            <Modal
                show={modalState.category_design_edit}
                onHide={() => setModalState({ ...modalState, category_design_edit: false })}
                aria-labelledby="example-modal-sizes-title-lg"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <h3 className="card-title mb-0">Edit Category Design</h3>
                </Modal.Header>
                <Modal.Body>
                    <Category_Design_Edit onSave={() => setModalState({ ...modalState, category_design_edit: false })} />
                </Modal.Body>
            </Modal>
            <ToastContainer />
        </section >

    );
}
